import { ImageSelect, ImageSelectOption } from '@goodlok/react-sdk'
import { FunctionComponent, useEffect, useMemo } from 'react'
import { useRoleIds } from '../app/utils/useRoleIds'
import { useVenues } from '../utilities/useVenues'
import styles from './AdminHead.module.sass'
import { useVenue } from './Head'

export type AdminHeadProps = {
	//
}

export const AdminHead: FunctionComponent<AdminHeadProps> = () => {
	const [roleIds, setRoleIds] = useRoleIds()
	const [venueId, setVenueId] = useVenue()

	const venues = useVenues()

	const activeVenue = useMemo(() => {
		if (!venues.data) {
			return null
		}
		return venues.data.find((venue) => venue.id === venueId)
	}, [venueId, venues])

	const roleOptions = useMemo(() => {
		const items: ImageSelectOption[] = []
		items.push({
			label: 'Všechny role',
			value: 'all',
			icon: 'team',
		})

		const employeeRoles = activeVenue?.employeeRoles

		employeeRoles?.forEach((employeeRole) => {
			const name = employeeRole.role?.name
			items.push({
				label: name ? name : 'Role bez názvu',
				value: employeeRole.role?.id ?? '',
			})
		})

		return items
	}, [activeVenue?.employeeRoles])

	useEffect(() => {
		if (!venues.data || !activeVenue) {
			return
		}
		if (
			roleIds === null ||
			!roleIds.every((roleId) =>
				activeVenue.employeeRoles.find((employeeRole) => employeeRole.role?.id === roleId)
			)
		) {
			setRoleIds(activeVenue.employeeRoles.map((employeeRole) => employeeRole.role?.id ?? ''))
		}
	}, [activeVenue, roleIds, setRoleIds, venues.data])

	const venueOptions = useMemo(() => {
		const items: ImageSelectOption[] = []
		if ((venues.data ?? []).length > 0) {
			venues.data?.forEach((venue) => {
				const name = venue.name
				items.push({
					label: name ? name : 'Podnik bez názvu',
					value: venue.id,
				})
			})
		}
		return items
	}, [venues])

	// update selected options on active venue switch
	const selectedRolesValue = useMemo(() => {
		const venueFilteredRoleIds = roleIds?.filter(
			(roleId) =>
				activeVenue?.employeeRoles.map((employeeRole) => employeeRole.role?.id).includes(roleId)
		)
		return roleOptions.length - 1 === (venueFilteredRoleIds ?? []).length
			? ['all']
			: venueFilteredRoleIds ?? ['all']
	}, [activeVenue?.employeeRoles, roleIds, roleOptions.length])

	return (
		<div className={styles.wrapper}>
			<div className={styles.fix}></div>
			<div className={styles.filters}>
				<ImageSelect
					name="role"
					// label="Role:"
					options={roleOptions}
					onChange={(options, actionMeta) => {
						if (actionMeta.action === 'select-option' && actionMeta.option?.value === 'all') {
							setRoleIds(
								roleOptions.map((option) => option.value).filter((value) => value !== 'all')
							)
						} else if (options && options.length > 0) {
							setRoleIds(options.map((option) => option.value).filter((value) => value !== 'all'))
						} else {
							setRoleIds(
								roleOptions.map((option) => option.value).filter((value) => value !== 'all')
							)
						}
					}}
					value={selectedRolesValue}
					isMulti
					closeMenuOnSelect={false}
					menuAlignment="left"
				/>
				<ImageSelect
					name="venue"
					// label="Podnik:"
					options={venueOptions}
					onChange={(option) => {
						setVenueId(option?.value || null)
						setRoleIds(null) // reset roleIds on venue change, so that all roles are selected after refetch
					}}
					value={venueId ?? undefined}
					isMulti={false}
					menuAlignment="left"
				/>
			</div>
		</div>
	)
}
